import React from 'react';
import './popup.scss';

const PopupTwoButtons = ({
  title,
  description,
  button1Text,
  button2Text,
  padding,
  closeModal,
  onClickBtn1,
  onClickBtn2,
  onKeyUp,
}) => {
  const customPadding = { padding: padding };
  function pressKey(event) {
    if (event.key === 'Enter') {
      closeModal();
    }
  }
  return (
    <div onKeyUp={onKeyUp}>
      <div className="modal-top-bar">
        {closeModal && (
          <div
            className="close-modal"
            onClick={closeModal}
            onKeyUp={pressKey}
            id="close-modal"
            tabIndex="0"
            aria-label="Close button"
          ></div>
        )}
      </div>
      <div className="popup-two-buttons" style={customPadding}>
        <h1 className="popup-title">{title}</h1>
        <p className="description">{description}</p>
        <div className="button-container">
          <button
            className="button-primary-modal"
            id="button-primary-modal"
            onClick={onClickBtn1}
            tabIndex="1"
            autoFocus
          >
            {button1Text}
          </button>
          <button
            className="button-secondary-modal"
            id="button-secondary-modal"
            onClick={onClickBtn2}
            tabIndex="2"
          >
            {button2Text}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PopupTwoButtons;
